<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import ConsignmentNoteField from '@/components/e-cmr/ConsignmentNoteField.vue'

const { t } = useI18n()
</script>
<template>
    <main class="consignment-note-sheet grid grid-cols-4 print:h-full print:bg-white">
        <!-- First Section -->
        <div class="flex flex-col col-span-3">
            <div
                class="flex flex-col border-y border-l border-black bg-primary-100 p-3 print:px-3 print:py-0 dark:bg-dark-500"
            >
                <ConsignmentNoteField translation="sender" field="1" />
                <slot name="sender" />
            </div>
            <div
                class="flex flex-col bg-primary-100 border-l border-b border-black p-3 print:px-3 print:py-0 dark:bg-dark-500 flex-1"
            >
                <ConsignmentNoteField translation="receiver" field="2" />
                <slot name="receiver" />
            </div>
        </div>
        <div
            class="qrParent flex flex-col col-span-1 border border-black col-start-4 row-start-1 items-center bg-primary-100 p-3 print:px-3 print:py-0 print:min-h-0 dark:bg-dark-500 h-full"
        >
            <h1
                class="text-xl font-bold uppercase text-primary-500 dark:text-primary-400"
                v-text="t('cmr')"
            />
            <h3
                class="text-lg font-semibold uppercase text-primary-400 dark:text-primary-300"
                v-text="t('shipment')"
            />
            <slot name="shipmentNumber" />
            <slot name="imageLogo" />
        </div>
        <!-- Second Section -->
        <div class="flex flex-col col-span-2 h-full">
            <div
                class="flex flex-col border-x border-black bg-primary-100 p-3 print:px-3 print:pt-0 print:pb-3.5 dark:bg-dark-500 h-full"
            >
                <ConsignmentNoteField translation="placeOfDelivery" field="3" />
                <slot name="placeOfDelivery" />
            </div>
            <div
                class="flex flex-col border-black border-t border-b border-x bg-primary-100 p-3 print:px-3 print:pt-0 print:pb-3.5 print:py-0 dark:bg-dark-500 h-full"
            >
                <ConsignmentNoteField translation="takenOverPlace" field="4" />
                <slot name="takenOverPlace" />
            </div>
            <div
                class="flex flex-col border-black border-x border-b bg-primary-100 p-3 print:px-3 print:py-0 dark:bg-dark-500 h-full"
            >
                <ConsignmentNoteField translation="documentsAttached" field="5" />
                <slot name="documentsAttached" />
            </div>
        </div>
        <div class="flex flex-col col-span-2 h-full">
            <div
                class="flex flex-col border-black border-r bg-primary-100 p-3 print:px-3 print:py-0 dark:bg-dark-500 h-full"
            >
                <ConsignmentNoteField translation="sender" field="16" />
                <slot name="shipper" />
            </div>
            <div
                class="flex flex-col border-black border-y border-r bg-primary-100 p-3 print:px-3 print:py-0 dark:bg-dark-500 h-full"
            >
                <ConsignmentNoteField translation="haulier" field="17" />
                <slot name="haulier" />
            </div>
            <div
                class="flex flex-col border-black border-b border-r bg-primary-100 p-3 print:px-3 print:py-0 dark:bg-dark-500 h-full"
            >
                <ConsignmentNoteField translation="shipperInstructions" field="18" />
                <slot name="shipperInstructions" />
            </div>
        </div>
        <!-- Third section -->
        <div
            class="colli col-span-full border-black border-x border-b px-3 mb-3 print:px-3 print:py-0 bg-primary-100 dark:bg-dark-500 h-full flex flex-col"
        >
            <slot name="collis" />
        </div>
        <!-- Fourth section ADR section remove if not needed -->
        <div
            class="flex justify-between bg-primary-100 dark:bg-dark-500 col-span-4 text-sm border-black border-x w-full"
        >
            <div class="flex w-fit border-r border-black py-6 p-3 print:px-3 print:py-0">
                <!--                    Add v-text props for ADR  -->
                <span class="flex gap-1">{{ t('class') }}: <span></span></span>
                <span class="flex mx-2 gap-1">{{ t('number') }}: <span></span></span>
                <span class="flex mx-2 gap-1">{{ t('letter') }}: <span></span></span>
                <span class="flex gap-1">{{ t('adr') }} <span></span></span>
            </div>
        </div>
        <!-- Fifth section -->
        <div class="flex flex-col col-span-1 h-full">
            <div
                class="flex flex-col border border-black bg-primary-100 px-3 pt-3 pb-[4.4rem] print:px-3 print:py-0 dark:bg-dark-500 h-full"
            >
                <ConsignmentNoteField translation="senderInstructions" field="13" />

                <slot name="senderInstructions" />
            </div>
            <div
                class="flex flex-col border-x border-black bg-primary-100 p-3 print:px-3 print:py-0 dark:bg-dark-500 h-full print:-mt-1.5 print:border-t"
            >
                <ConsignmentNoteField translation="instructionsPayment" field="14" />

                <slot name="instructionsPayment" />
            </div>
        </div>
        <!-- Sixth section -->
        <div class="flex flex-col col-span-3 h-full">
            <div
                class="flex flex-col border-r border-t border-black bg-primary-100 p-3 print:px-3 print:py-0 dark:bg-dark-500 h-full"
            >
                <ConsignmentNoteField translation="specialAgreements" field="19" />

                <slot name="specialAgreements" />
            </div>
            <table class="w-full border-black text-left bg-primary-100 dark:bg-dark-500">
                <!-- Table Header -->
                <thead>
                    <tr class="">
                        <th class="border-t border-black px-4 py-2 print:py-1 w-1/4">
                            <ConsignmentNoteField translation="paidBy" field="20" />
                        </th>
                        <th class="border border-black px-4 py-2 print:py-1 text-center">
                            <ConsignmentNoteField translation="sender" center-elements />
                        </th>
                        <th class="border border-black px-4 py-2 print:py-1 text-center">
                            <ConsignmentNoteField translation="currency" center-elements />
                        </th>
                        <th class="border border-black px-4 py-2 print:py-1 text-center">
                            <ConsignmentNoteField translation="consignee" center-elements />
                        </th>
                    </tr>
                </thead>

                <!-- Table Body -->
                <tbody>
                    <tr>
                        <td class="border-t border-black px-4 py-2 print:py-1">
                            <ConsignmentNoteField translation="carriageCharges" />
                        </td>
                        <td class="border border-black"></td>
                        <td class="border border-black"></td>
                        <td class="border border-black"></td>
                    </tr>
                    <tr>
                        <td class="border-t border-black px-4 py-2 print:py-1">
                            <ConsignmentNoteField translation="balance" />
                        </td>
                        <td class="border border-black"></td>
                        <td class="border border-black"></td>
                        <td class="border border-black"></td>
                    </tr>
                    <tr>
                        <td class="border-t border-black px-4 py-2 print:py-1">
                            <ConsignmentNoteField translation="cargoInsurance" />
                        </td>
                        <td class="border border-black"></td>
                        <td class="border border-black"></td>
                        <td class="border border-black"></td>
                    </tr>
                    <tr>
                        <td class="border-t border-r border-black px-4 py-2 print:py-1">
                            <ConsignmentNoteField translation="totalPaid" />
                        </td>
                        <td class="border-t border-r border-black"></td>
                        <td class="border-t border-r border-black"></td>
                        <td class="border-t border-r border-black"></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div
            class="w-full justify-between gap-2 col-span-4 border-y border-x border-black flex bg-primary-100 dark:bg-dark-500"
        >
            <div
                class="flex w-full text-center px-3.5 print:px-3 py-1 border-r border-black items-center gap-2"
            >
                <div class="flex w-1/2 space-x-4">
                    <ConsignmentNoteField translation="establishedIn" field="21" />
                    <div class="w-1/2 flex items-center">
                        <slot name="establishedIn" />
                    </div>
                </div>
                <div class="flex w-1/2 space-x-4">
                    <ConsignmentNoteField translation="on" />
                    <div class="w-1/2 flex items-center">
                        <slot name="establishedOn" />
                    </div>
                </div>
            </div>

            <div class="flex w-[48.5%] text-center px-2 py-1 border-black items-center gap-2">
                <ConsignmentNoteField translation="cashOnDelivery" field="22" />
            </div>
        </div>
        <!--Seventh section-->
        <div class="flex col-span-full h-full break-inside-avoid border-x border-black">
            <div
                class="flex flex-col w-1/2 border-black overflow-hidden dark:bg-dark-500 bg-primary-100 h-full py-1 pl-2 pr-3 print:pl-2 print:pr-0"
            >
                <ConsignmentNoteField translation="senderSignature" field="23" />
                <slot name="senderSignature" />

                <div class="h-4 w-full" />
            </div>
            <div
                class="flex flex-col w-1/2 border-x border-black dark:bg-dark-500 bg-primary-100 h-full py-1 pl-2 pr-3 print:pl-2 print:pr-0"
            >
                <ConsignmentNoteField translation="driverSignature" field="24" />
                <slot name="driverSignature" />
                <div class="h-4 w-full" />
            </div>
            <div
                class="flex flex-col w-1/2 border-black overflow-hidden dark:bg-dark-500 bg-primary-100 h-full px-2 py-1"
            >
                <ConsignmentNoteField translation="receiverSignature" field="25" />
                <slot name="receiverSignature" />
                <div class="h-4 w-full" />
            </div>
        </div>
        <!-- Delivery Note -->
        <div class="flex col-span-full h-full break-inside-avoid border border-black">
            <div
                class="flex flex-col w-full bg-primary-100 dark:bg-dark-500 py-1 px-3 print:pl-2 print:pr-0"
            >
                <ConsignmentNoteField translation="deliveryNote" />
                <slot name="deliveryNote" />
                <div class="h-4 w-full" />
            </div>
        </div>
    </main>
</template>
<style>
@media print {
    .consignment-note-sheet span {
        font-size: 0.6rem;
    }
    .consignment-note-sheet .qrParent h1,
    .consignment-note-sheet .qrParent h3 {
        font-size: 1rem;
        line-height: 1.15;
    }
    .consignment-note-sheet .qr {
        width: 7rem;
    }
    .consignment-note-sheet .colli div {
        padding-top: 0rem;
        padding-bottom: 0rem;
        padding-left: 0.2rem;
        padding-right: 0.2rem;
    }
    .consignment-note-sheet table {
        font-size: 0.6rem;
    }
}
</style>
